module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pers-tab2-1",
      "name": "hrms32e-tab2-tab1"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 pull-left"
  }, [_c('div', {
    staticClass: "col-xs-12  card-ui clearfix border-top-color-skin"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix",
    on: {
      "click": _vm.toggleSubTopic1
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC3']['20']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic1),
      expression: "subTopic1"
    }],
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC3']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.adrreg),
      expression: "detail.adrreg"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:100'),
      expression: "'max:100'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "adrreg",
      "name": "adrreg",
      "maxlength": "100",
      "data-vv-name": "adrreg",
      "has-error": _vm.errors.has('adrreg')
    },
    domProps: {
      "value": (_vm.detail.adrreg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "adrreg", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('adrreg')),
      expression: "errors.has('adrreg')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('adrreg')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC3']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.codcount[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.codcntyr),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codcntyr", $$v)
      },
      expression: "detail.codcntyr"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC3']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.codprovr[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.codprovr),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codprovr", $$v)
      },
      expression: "detail.codprovr"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC3']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.arrCoddistr[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.coddistr),
      callback: function($$v) {
        _vm.$set(_vm.detail, "coddistr", $$v)
      },
      expression: "detail.coddistr"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC3']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.arrCodsubdistr[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.codsubdistr),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codsubdistr", $$v)
      },
      expression: "detail.codsubdistr"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC3']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.codpostr),
      expression: "detail.codpostr"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('numeric|max:5'),
      expression: "'numeric|max:5'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "codpostr",
      "name": "codpostr",
      "maxlength": "5",
      "data-vv-name": "codpostr",
      "has-error": _vm.errors.has('codpostr')
    },
    domProps: {
      "value": (_vm.detail.codpostr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "codpostr", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codpostr')),
      expression: "errors.has('codpostr')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codpostr')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC3']['170']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.email_emp),
      expression: "detail.email_emp"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:50'),
      expression: "'max:50'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "email_emp",
      "name": "email_emp",
      "maxlength": "50",
      "data-vv-name": "email_emp",
      "has-error": _vm.errors.has('email_emp')
    },
    domProps: {
      "value": (_vm.detail.email_emp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "email_emp", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email_emp')),
      expression: "errors.has('email_emp')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('email_emp')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 pull-right"
  }, [_c('div', {
    staticClass: "col-xs-12  card-ui clearfix border-top-color-skin"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix",
    on: {
      "click": _vm.toggleSubTopic2
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC3']['30']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic2),
      expression: "subTopic2"
    }],
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC3']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.adrcont),
      expression: "detail.adrcont"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:100'),
      expression: "'max:100'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "adrcont",
      "name": "adrcont",
      "maxlength": "100",
      "data-vv-name": "adrcont",
      "has-error": _vm.errors.has('adrcont')
    },
    domProps: {
      "value": (_vm.detail.adrcont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "adrcont", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('adrcont')),
      expression: "errors.has('adrcont')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('adrcont')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC3']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.codcount[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.codcntyc),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codcntyc", $$v)
      },
      expression: "detail.codcntyc"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC3']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.codprovr[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.codprovc),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codprovc", $$v)
      },
      expression: "detail.codprovc"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC3']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.arrCoddistc[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.coddistc),
      callback: function($$v) {
        _vm.$set(_vm.detail, "coddistc", $$v)
      },
      expression: "detail.coddistc"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC3']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.arrCodsubdistc[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.codsubdistc),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codsubdistc", $$v)
      },
      expression: "detail.codsubdistc"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC3']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.codpostc),
      expression: "detail.codpostc"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('numeric|max:5'),
      expression: "'numeric|max:5'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "codpostc",
      "name": "codpostc",
      "maxlength": "5",
      "data-vv-name": "codpostc",
      "has-error": _vm.errors.has('codpostc')
    },
    domProps: {
      "value": (_vm.detail.codpostc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "codpostc", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codpostc')),
      expression: "errors.has('codpostc')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codpostc')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row clearfix"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS32EC3']['160']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.numtelec),
      expression: "detail.numtelec"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:20'),
      expression: "'max:20'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "numtelec",
      "name": "numtelec",
      "maxlength": "20",
      "data-vv-name": "numtelec",
      "has-error": _vm.errors.has('numtelec')
    },
    domProps: {
      "value": (_vm.detail.numtelec)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "numtelec", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numtelec')),
      expression: "errors.has('numtelec')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('numtelec')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray pull-left",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.togglePage(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))]), _vm._v(" "), (_vm.validateStaappr) ? _c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.callSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-799ee91f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms32e/tab2_1.vue
// module id = 3905
// module chunks = 1